/*
  ft-complements.js — "Birlikte iyi gider" (sections/ft-complements.liquid).
  1. Kartları sayfadaki ilk satın alma kutusunda ([data-ft-buy]) paket seçiminin (.ft-buy__packs) altına taşır.
  2. Seçili hatta ait grubu gösterir (hat sekmesi / paket değişince günceller).
  3. Buton toplamını (paket × adet + işaretli ürünler) günceller.
  4. Ana "Sepete ekle", yapışkan bar ya da kapanış butonu tıklanınca v4.js'in gönderdiği /cart/add.js isteğine
     işaretli ürünleri ekler (tek istek: ya hepsi eklenir ya hiçbiri). Başarılı eklemeden sonra işaretler kalkar.
  ES5, bağımlılık yok. v4.js / ft-buy.js'e dokunmaz.
*/
(function () {
  'use strict';
  if (window.__ftCmp) return;
  window.__ftCmp = true;

  var pending = null; // { items, until }

  function all(scope, sel) { return [].slice.call(scope.querySelectorAll(sel)); }
  function money(c) { return window.v4FormatMoney ? window.v4FormatMoney(c) : Math.round(c / 100) + ' TL'; }
  function buyRoot() { return document.querySelector('[data-ft-buy]'); }
  function block() { return document.querySelector('[data-ft-cmp]'); }

  function currentLine(root) {
    var tab = root.querySelector('[data-line-tab][aria-selected="true"]');
    if (tab) return tab.getAttribute('data-line-tab');
    var radio = root.querySelector('input[name=id]:checked');
    var pack = radio && radio.closest('.v4-pack');
    return pack ? pack.getAttribute('data-line') : '1';
  }

  function visibleGroup(cmp) {
    return all(cmp, '[data-cmp-line]').filter(function (g) { return !g.hidden; })[0] || null;
  }
  function checked(cmp) {
    var g = visibleGroup(cmp);
    return g ? all(g, '.ft-cmp__check:checked') : [];
  }

  function paint() {
    var root = buyRoot();
    var cmp = block();
    if (!root || !cmp) return;
    var line = currentLine(root);
    var any = false;
    all(cmp, '[data-cmp-line]').forEach(function (g) {
      var on = g.getAttribute('data-cmp-line') === line && !!g.querySelector('.ft-cmp__check');
      if (!on) all(g, '.ft-cmp__check:checked').forEach(function (c) { c.checked = false; });
      g.hidden = !on;
      if (on) any = true;
    });
    cmp.hidden = !any;
    total(root, cmp);
  }

  function total(root, cmp) {
    var radio = root.querySelector('input[name=id]:checked:not(:disabled)');
    if (!radio) return;
    var qtyInput = root.querySelector('[data-qty-input]');
    var qty = parseInt(qtyInput && qtyInput.value, 10);
    if (isNaN(qty) || qty < 1) qty = 1;
    var sum = (parseInt(radio.getAttribute('data-price'), 10) || 0) * qty;
    checked(cmp).forEach(function (c) { sum += parseInt(c.getAttribute('data-price'), 10) || 0; });
    var label = ' · ' + money(sum);
    var section = root.closest('section') || document;
    all(root, '[data-total]').forEach(function (el) { el.textContent = label; });
    all(section, '[data-ft-total]').forEach(function (el) { el.textContent = label; });
  }

  function place() {
    var root = buyRoot();
    var cmp = block();
    if (!root || !cmp) return false;
    if (!root.contains(cmp)) {
      var packs = root.querySelector('.ft-buy__packs') || root.querySelector('[data-packs]');
      if (!packs) return false;
      packs.parentNode.insertBefore(cmp, packs.nextSibling);
    }
    paint();
    return true;
  }

  /* v4.js'in paket / sekme / adet değişiminden sonra (aynı olay turunun sonunda) yeniden boya */
  function later() { window.setTimeout(paint, 0); }

  function arm(source) {
    var cmp = block();
    if (!cmp || cmp.hidden) return;
    var items = checked(cmp).map(function (c) {
      return { id: parseInt(c.getAttribute('data-cmp-variant'), 10), quantity: 1, properties: { _birlikte_al: 'evet' } };
    });
    pending = items.length ? { items: items, until: Date.now() + 2500, source: source } : null;
  }

  /* /cart/add.js isteğine işaretli ürünleri ekle (yalnız v4.js'in {items:[…]} gövdeli, sections içermeyen isteği) */
  var baseFetch = window.fetch;
  window.fetch = function (resource, init) {
    try {
      var u = typeof resource === 'string' ? resource : (resource && resource.url) || '';
      if (pending && Date.now() < pending.until && /\/cart\/add\.js/.test(u) && init && typeof init.body === 'string') {
        var body = JSON.parse(init.body);
        if (body && Array.isArray(body.items) && !body.sections) {
          var extra = pending.items;
          var source = pending.source;
          pending = null;
          body.items = body.items.concat(extra);
          init = Object.assign({}, init, { body: JSON.stringify(body) });
          var p = baseFetch.call(this, resource, init);
          p.then(function (res) {
            if (!res.ok) return;
            var cmp = block();
            if (cmp) all(cmp, '.ft-cmp__check:checked').forEach(function (c) { c.checked = false; });
            later();
            if (window.v4Track) {
              window.v4Track('v4_complement_add', {
                count: extra.length,
                variant_ids: extra.map(function (i) { return String(i.id); }).join(','),
                source: source
              });
            }
          }, function () {});
          return p;
        }
      }
    } catch (e) { /* gövde okunamazsa isteğe dokunma */ }
    return baseFetch.apply(this, arguments);
  };

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-ft-buy] [data-add]')) arm('main');
    else if (t.closest('[data-sticky-add]')) arm('sticky');
    else if (t.closest('[data-ft-proxy-add]')) arm('close');
    if (t.closest('[data-ft-buy]') || t.closest('[data-ft-catnav]')) later();
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-ft-buy]')) {
      later();
      if (t.classList.contains('ft-cmp__check') && window.v4Track) {
        window.v4Track('v4_complement_toggle', { variant_id: t.getAttribute('data-cmp-variant'), on: t.checked });
      }
    }
  });
  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-ft-buy] [data-qty-input]')) later();
  });

  function boot() {
    if (!place()) {
      // satın alma kutusu geç kurulursa (tema editörü) bir süre daha dene
      var tries = 0;
      var iv = window.setInterval(function () {
        if (place() || ++tries > 20) window.clearInterval(iv);
      }, 150);
    }
  }

  document.addEventListener('shopify:section:load', function () { window.setTimeout(boot, 50); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', paint);
})();
